import React from "react";
import { obtenerPrimero } from "../Utils/configuracionInicial.constants";

export const ProgresoConfiguracionInicial = ({ progreso, etiquetaEtapa }) => {
  const porcentaje = Number(obtenerPrimero(progreso, ["Porcentaje", "porcentaje"], 0)) || 0;
  const resueltas = Number(obtenerPrimero(progreso, ["Resueltas", "resueltas"], 0)) || 0;
  const total = Number(obtenerPrimero(progreso, ["TotalAplicables", "totalAplicables", "Total", "total"], 0)) || 0;
  const paraDespues = Number(obtenerPrimero(progreso, ["ParaDespues", "paraDespues"], 0)) || 0;
  const porcentajeSeguro = Math.min(100, Math.max(0, porcentaje));

  return (
    <section className="ci-journey-progress" aria-label={`Progreso ${porcentajeSeguro}%`}>
      <div className="ci-journey-progress__heading">
        <span>Tu recorrido</span>
        <strong>{etiquetaEtapa}</strong>
      </div>
      <div className="ci-journey-progress__track" role="progressbar" aria-label="Avance del asistente" aria-valuemin={0} aria-valuemax={100} aria-valuenow={porcentajeSeguro}>
        <span style={{ width: `${porcentajeSeguro}%` }} />
      </div>
      <small>
        {resueltas} de {total} decisiones resueltas
        {paraDespues > 0 ? ` · ${paraDespues} para después` : ""}
      </small>
    </section>
  );
};
